"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditableText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const constants_1 = require("../../utils/constants");
const editableText_style_1 = __importDefault(require("./editableText.style"));
class EditableText extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            value: this.props.value
        };
        this.handleClickOutside = event => {
            const { editMode } = this.props;
            if (editMode && !this.element.contains(event.target)) {
                this.exit();
            }
        };
        this.exit = () => {
            const { toggleEditMode, value } = this.props;
            this.setState({ value });
            toggleEditMode();
        };
        this.onChange = event => {
            this.setState({ value: event.target.value });
        };
        this.handleKeyUp = event => {
            if (event.keyCode === constants_1.escapeKeyCode) {
                this.exit();
            }
            else if (event.keyCode === constants_1.enterKeyCode && event.target.value !== '') {
                this.props.onSubmit(event.target.value);
            }
        };
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.state.value !== nextProps.value &&
            this.props.value !== nextProps.value) {
            this.setState({ value: nextProps.value });
        }
    }
    selectAll(e) {
        e.target.select();
    }
    render() {
        const { editMode, placeholder } = this.props;
        const { value } = this.state;
        if (!editMode)
            return jsx_runtime_1.jsx("div", { children: value }, void 0);
        return (jsx_runtime_1.jsx("input", { type: "text", placeholder: placeholder, value: value, onChange: this.onChange, onKeyUp: this.handleKeyUp, ref: e => {
                this.element = e;
            }, autoFocus: true, onFocus: this.selectAll }, void 0));
    }
}
exports.EditableText = EditableText;
EditableText.propTypes = {
    onSubmit: prop_types_1.default.func.isRequired,
    value: prop_types_1.default.string,
    placeholder: prop_types_1.default.string,
    editMode: prop_types_1.default.bool.isRequired,
    toggleEditMode: prop_types_1.default.func.isRequired
};
EditableText.defaultProps = {
    value: '',
    placeholder: 'title'
};
exports.default = react_jss_1.default(editableText_style_1.default)(EditableText);
//# sourceMappingURL=index.js.map